import { isRecord } from "@tsmono/util";

const kScannerReferencesKey = "scanner_references";
const kScannerContentKey = "scanner_content";

export type ScannerRefType = "message" | "event";

export interface ScannerRefEntry {
  type: ScannerRefType;
  id: string;
  cite: string;
}

type Metadata = Record<string, unknown> | null | undefined;

export function isScannerScore(metadata: Metadata): boolean {
  return !!metadata && kScannerReferencesKey in metadata;
}

export function metadataWithoutScannerKeys(
  metadata: Metadata
): Record<string, unknown> {
  if (!metadata) return {};
  const {
    [kScannerReferencesKey]: _refs,
    [kScannerContentKey]: _content,
    ...rest
  } = metadata;
  return rest;
}

export function readScannerReferences(metadata: Metadata): ScannerRefEntry[] {
  if (!metadata) return [];
  const raw = metadata[kScannerReferencesKey];
  if (!Array.isArray(raw)) return [];
  const entries: ScannerRefEntry[] = [];
  for (const item of raw) {
    if (!isRecord(item)) continue;
    const { type, id, cite } = item;
    if (
      (type === "message" || type === "event") &&
      typeof id === "string" &&
      typeof cite === "string" &&
      cite.length > 0
    ) {
      entries.push({ type, id, cite });
    }
  }
  return entries;
}
